import { Injectable, OnDestroy, TemplateRef } from '@angular/core';
import { asapScheduler, BehaviorSubject } from 'rxjs';
import { observeOn } from 'rxjs/operators';

/** One registry per Central shell; pages retain ownership of their tab bindings. */
@Injectable()
export class CentralNavigationService implements OnDestroy {
    private _template = new BehaviorSubject<TemplateRef<unknown>>(null);
    readonly template$ = this._template.pipe(observeOn(asapScheduler));
    show(template: TemplateRef<unknown>): void { this._template.next(template); }
    clear(template: TemplateRef<unknown>): void {
        if (this._template.value === template) { this._template.next(null); }
    }
    ngOnDestroy(): void { this._template.next(null); this._template.complete(); }
}
